module.exports = __webpack_public_path__ + "static/media/TT.90d1f42c.svg";